import React, { useEffect, useRef, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import "./index.less";
import {
  TwoSliderHorizontalIcon,
  NavigationIcon,
  FoodAndDrinkIcon,
  SortDownIcon,
  CheckIcon,
} from "@/icons";
import { useFilterContext } from "@/ui/head-bar/filter-context";
import { FiltersDialog } from "@/ui/filters/desktop";
import Popover from "@/ui/popover";
import { observer } from "mobx-react-lite";

const filters = [
  {
    key: "filters",
    icon: <TwoSliderHorizontalIcon></TwoSliderHorizontalIcon>,
    label: "Filters",
  },
  {
    key: "location",
    icon: <NavigationIcon></NavigationIcon>,
    label: "Location",
  },
  {
    key: "cuisines",
    icon: <FoodAndDrinkIcon></FoodAndDrinkIcon>,
    label: "Cuisines",
  },
];

function Filters() {
  const { t } = useTranslation();
  const { filterParams, state, setState, sums, setFakeState, order_by, setOrderBy } =
    useFilterContext();
  const [activeFilters, setActiveFilters] = React.useState("");
  const [isSortActive, setIsSortActive] = useState(false);
  const ref = useRef(null);
  const dialogConfig = useMemo(() => {
    return {
      title: t(`Browse.${activeFilters}`),
      open: activeFilters !== "",
      type: activeFilters,
      close: () => setActiveFilters(""),
    };
  }, [activeFilters]);

  useEffect(() => {
    setFakeState({ ...state });
  }, [activeFilters]);

  const sortLabel = useMemo(() => {
    const options = Array.isArray(filterParams?.order_by)
      ? filterParams.order_by
      : [];
    if (options.length === 0) return t("Browse.sort");

    const selectedValue = order_by;
    const selected = options.find((opt) => opt?.value === selectedValue);
    return selected?.name || t("Browse.sort");
  }, [filterParams?.order_by, order_by, t]);

  return (
    <div className="explore-filters">
      <Popover
        placement="bottom-start"
        trigger="click"
        open={isSortActive}
        fixed={true}
        content={
          <div className="explore-sort-popover-content" ref={ref}>
            {filterParams?.order_by?.map((option) => (
              <div
                key={option.value}
                className={cn("explore-sort-popover-item", {
                  active: order_by === option.value,
                })}
                onClick={() => {
                  setOrderBy(option.value);
                  setIsSortActive(false);
                }}
              >
                <div className="label">{option.name}</div>
                {order_by === option.value && <CheckIcon></CheckIcon>}
              </div>
            ))}
          </div>
        }
        onOpenChange={(open) => {
          setIsSortActive(open);
        }}
        overlayClassName="explore-sort-popover"
      >
        <div
          className={cn("explore-filter-item explore-filter-item-sort", {
            active: isSortActive,
          })}
        >
          <SortDownIcon></SortDownIcon>
          <span>{sortLabel}</span>
        </div>
      </Popover>

      {filters.map((filter) => (
        <div
          key={filter.key}
          className="explore-filter-item"
          onClick={() => setActiveFilters(filter.key)}
        >
          {filter.icon}
          <span>{t(`Browse.${filter.key}`)}</span>
          {sums[filter.key] > 0 && (
            <div className="explore-filter-item-badge">{sums[filter.key]}</div>
          )}
        </div>
      ))}
      {dialogConfig.open && <FiltersDialog {...dialogConfig}></FiltersDialog>}
    </div>
  );
}

export default observer(Filters);
